import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setParcelsForStagesInStore, updateParcelObjectWithData } from "../../actions/parcels";
import { updateToastInfo } from "../../actions/settings";
import { updateSpinnerState } from "../../actions/spinner";
import ParcelStatusPage from "../../components/common/parcelStatusPages";
import RescheduleModal from "../../components/common/RescheduleModal";
import { getParcelsByStatusAndSubStatus, updateParcelDataWithInfo } from "../../parse-functions/parcels";
import { Routes } from "../../router/routes";
import { convertArrayToObj } from "../../utils/json";
import { returnRegisterTableColumns } from "./returnsUtils";
import { setFiltersInStore } from "../../actions/filters";
import { returnEndOfDay, returnStartOfDay } from "../../utils/datetime";

const ReturnRegisterList = () => {
    const pageStatus = "returnok"
    const reduxStoreKeyPageName = "returnokScheduled";
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const breadCrumbItems = [{
        title: t("Returns"),
        link: Routes.Returns.ReturnOK.path
    }, {
        title: t("Return Register"),
        link: Routes.Returns.ReturnRegister.path
    }];
    const [selectedParcelId, setSelectedParcelId] = useState(null);
    const storeCode = useSelector((state) => state?.user?.warehouse?.warehouseCode || "");
    const parcels = useSelector((state) => state?.parcels?.[reduxStoreKeyPageName] || {});
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const filtersValue = useSelector((state) => state.filters?.[reduxStoreKeyPageName]);
    const zone = useSelector((state) => state?.user?.warehouse?.zone || "");
    
    const onRowSelect = (value, objectId) => {
        if (selectedParcelId) {
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Only 1 item allowed'),
                message: t("Please deselect other item before choosing this")
            }))
        } else {
            if (value) {
                setSelectedParcelId(objectId);
            } else {
                setSelectedParcelId(null);
            }
        }
    }
    const getAvailableParcels = async (startDate, endDate) => {
        dispatch(updateSpinnerState(true));
        try {
            const filters = {
                subStatus: [pageStatus],
                storeCode,
                returnScannedAt: true,
                startDate: new Date(startDate),
                endDate: new Date(endDate),
                zone
            };
            const parcels = await getParcelsByStatusAndSubStatus(filters);
            dispatch(setParcelsForStagesInStore(reduxStoreKeyPageName, convertArrayToObj(JSON.parse(JSON.stringify(parcels)), "objectId")))
            dispatch(updateSpinnerState(false));
            dispatch(updateToastInfo({
                show: true,
                type: 'success',
                title: t('Orders fetched'),
                message: t("You can Track your rescheduled items from here")
            }))

        } catch (e) {
            dispatch(updateSpinnerState(false));
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Error'),
                message: t(e.message)
            }))
        }
    }
    const handleFiltersSubmit = (startDate, endDate) => {
        dispatch(setFiltersInStore({
            pageType: reduxStoreKeyPageName,
            data: {
              startDate: new Date(startDate),
              endDate: new Date(endDate)
            }
          }))
        getAvailableParcels(startDate, endDate);
    };

    const onRefreshClick = () => {
        const currentStartDate = filtersValue.startDate ? new Date(filtersValue.startDate): returnStartOfDay(new Date());
        const currentEndDate = filtersValue.endDate ? new Date(filtersValue.endDate) : returnEndOfDay(new Date());
        getAvailableParcels(currentStartDate, currentEndDate);
    }
    const handleShowRescheduleModal = () => {
        setShowRescheduleModal(false);
    }
    const onRescheduleConfirm = async (data) => {
        dispatch(updateSpinnerState(true));
        try {
            const parcelUpdateItem = {
                objectId: data?.parcelObjectId,
                data: {
                    date: data?.date,
                    remarks: data?.remarks
                }
            }
            await updateParcelDataWithInfo(parcelUpdateItem);
            dispatch(updateParcelObjectWithData(reduxStoreKeyPageName, parcelUpdateItem));
            setShowRescheduleModal(false);
            dispatch(updateToastInfo({
                show: true,
                type: 'success',
                title: t('Parcel Rescheduled'),
                message: t("This parcel has been rescheduled for the chosen date")
            }))
            dispatch(updateSpinnerState(false));

        } catch(e) {
            dispatch(updateSpinnerState(false));
        }
    };

    const handleItemBulkUpdate = (actionId) => {
        if (selectedParcelId) {
            switch (actionId) {
                case "reschedule": {
                    setShowRescheduleModal(true);
                    break;
                }
                default: {
                    dispatch(updateToastInfo({
                        show: true,
                        type: 'danger',
                        title: t('Select an Action'),
                        message: t("Please select an action from the dropdown")
                    }))
                    break;
                }
            }
        } else {
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Select Item'),
                message: t("Please select an item to take action")
            }))
        }
    }

    return (
        <>
            <ParcelStatusPage
                pageType={pageStatus}
                filtersValue={filtersValue}
                filterSubmit={handleFiltersSubmit}
                tableData={parcels}
                tableColumns={returnRegisterTableColumns(onRowSelect)}
                handleRefresh={onRefreshClick}
                pageTitle={t("Return Register")}
                breadCrumbItems={breadCrumbItems}
                pageSubTitle={t("All the Returned Parcels of your warehouse that have been recheduled")}
                searchPlaceHolder={t("Search by Invoice No. in Database")}
                handleItemBulkUpdate={handleItemBulkUpdate}
                bulkActionOptions={[{
                    label: "Edit",
                    value: "reschedule"
                }]}
                enableBulkActions={selectedParcelId && Object.keys(parcels)?.length > 0}
            />
            <RescheduleModal
                disableTargetDropdown
                targetDropdownOptions={[]}
                selectedParcelId={selectedParcelId}
                pageStatus={reduxStoreKeyPageName}
                showModal={showRescheduleModal}
                closeModal={handleShowRescheduleModal}
                onConfirm={onRescheduleConfirm} />
        </>
    )
}
export default ReturnRegisterList;